// Loading
export const PRODUCT_REQUEST = "PRODUCT_REQUEST";
//  Product failure
export const PRODUCT_FAILURE = "PRODUCT_FAILURE";
// Geting Products SuccessFull
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
